import DragAndDropArea from 'core/components/DragAndDropArea';
import { useDragAndDropImage } from './hooks';
/* eslint-disable react/prop-types */ // TODO: add props

export const DragAndDropImage = ({
  blockData = {},
  blockResponse = {},
  onResponseChange,
  readOnly,
  reviewMode,
}) => {
  const {
    imageUrl,
    draggableAnnotations,
    dropzoneAnnotations,
    draggableToContainingDropzoneMap,
    onDraggableRelocated,
  } = useDragAndDropImage(blockData, onResponseChange, blockResponse);

  return (
    <DragAndDropArea
      draggableAnnotations={draggableAnnotations}
      dropzoneAnnotations={dropzoneAnnotations}
      imageUrl={imageUrl}
      draggableToContainingDropzoneMap={draggableToContainingDropzoneMap}
      onDraggableRelocated={onDraggableRelocated}
    />
  );
};
